import React from "react";
import { Helmet } from "react-helmet-async";

export function Seo({
  title,
  description,
  path = "/",
  image = "https://madridcampogrande.es/og/default.jpg",
  noindex = false,
}) {
  const url = `https://madridcampogrande.es${path}`;
  return (
    <Helmet>
      <html lang="es" />
      <title>{title}</title>

      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
